import ApiService from '../../../../shared/services/ApiService';

export default {
    updateCompanySettings(data){
        return ApiService.post('company-settings', data);
    },
    getBreakCodes() {
        return ApiService.get('break-codes');
    },
    getBreakCodeById(id) {
        return ApiService.get(`break-codes/${id}`);
    },
    saveBreakCode(data) {
        return ApiService.post('break-codes', data);
    },
    saveBreakCodes(data) {
        return ApiService.post('break-codes-multi', data);
    },
    updateBreakCode(id, data) {
        return ApiService.put(`break-codes/${id}`, data);
    },

    deleteBreakCode(id) {
        return ApiService.delete(`break-codes/${id}`);
    },
    getBreakRules(labels) {
        return [
            { value: 1, label: labels.get('manual') },
            { value: 2, label: labels.get('automatic') },
            { value: 3, label: labels.get('custom') },
        ];
    },
    getBreakTypes(labels) {
        return [
            { value: 1, label: labels.get('paid') },
            { value: 2, label: labels.get('unpaid') }
        ];
    },
    getAdvancedBreakTypes() {
        return ApiService.get('advanced-break-types');
    },
    saveAdvancedBreakTypes(data) {
        return ApiService.post('advanced-break-types', data);
    },
    deleteAdvancedBreakType(id) {
        return ApiService.delete(`advanced-break-types/${id}`)
    },
  /*  updateAdvancedBreakType(id, data) {
        return ApiService.post(`advanced-break-types/${id}`, data);
    },*/
    updateAdvancedBreakType(id, data) {
        return ApiService.post(`update-advanced-break-type`, data);
    },
}